import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3i69rg8u20: FaireBrandEntity = {
  token: "b_3i69rg8u20",
  type: "brand",
  name: "Freshwater Curated Goods",
  avatarUrl:
    "https://cdn.faire.com/fastly/c9d7f4ec487440ceaf2d7b94852ee9c7ffa101f656d301deeef734397c569eb3.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/deb9c37c3ec69352fb192b39257b0b43e65884f91819e2ab5e81bae11f379ab8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c9d7f4ec487440ceaf2d7b94852ee9c7ffa101f656d301deeef734397c569eb3.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/deb9c37c3ec69352fb192b39257b0b43e65884f91819e2ab5e81bae11f379ab8.jpeg",
  location: "Augusta, GA, USA",
  minimumOrderDollars: 274,
  rating: 4.9,
  reviewCount: 153,
  isTopShop: true,
  isInsider: true,
  description:
    "Freshwater Curated Goods is a women-owned lifestyle brand crafting playful, high-quality acrylic accessories inspired by lake days, beach towns, and the easygoing spirit of life near the water. Founded in 2017 by sisters Danielle and Brianne in Augusta, Georgia, Freshwater began as a creative outlet and travel fund and has since grown into a nationally recognized brand loved for its nostalgic style, thoughtful details, and regionally inspired collections.\n\nBest known for reimagining the vintage motel keychain and creating bestselling bag charms for locals, travelers, and water lovers, Freshwater continues to evolve through purposeful design and a focus on pieces that resonate with communities across all regions—especially those connected to life by the water. Every item is designed in-house and handcrafted in our Augusta studio, where our small team creates goods meant to be used, gifted, and loved every day.\n\nNature of Handcrafted Products: All Freshwater products are made to order and crafted by hand using raw materials. Slight variations or light surface imperfections may naturally occur and add to the character of each piece. We reserve the right to make product improvements or updates as needed.",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:44:59.783Z",
    importedBy: "entity-db-cli",
  },
};
